module.exports = __webpack_public_path__ + "img/寫作專區.6d3e5f5c.png";